import { orpc } from "@shared/lib/orpc";

/*
 * Query options shared by the Channels routes (loaders) and screens, so their keys match and
 * the server-prefetched data is what the screens read.
 */

export const numbersQuery = (organizationId: string) =>
	orpc.channels.whatsapp.list.queryOptions({ input: { organizationId } });

export const numberQuery = (organizationId: string, connectionId: string) =>
	orpc.channels.whatsapp.get.queryOptions({
		input: { organizationId, connectionId },
	});

export const alertsQuery = (organizationId: string, connectionId?: string) =>
	orpc.channels.whatsapp.alerts.list.queryOptions({
		input: { organizationId, ...(connectionId ? { connectionId } : {}) },
	});

export const costsQuery = (organizationId: string, connectionId?: string) =>
	orpc.channels.whatsapp.costs.queryOptions({
		input: { organizationId, ...(connectionId ? { connectionId } : {}) },
	});

export const contentCheckQuery = (organizationId: string) =>
	orpc.channels.whatsapp.contentCheck.status.queryOptions({
		input: { organizationId },
	});

export const entryLinksQuery = (organizationId: string, connectionId: string) =>
	orpc.channels.whatsapp.entryLinks.list.queryOptions({
		input: { organizationId, connectionId },
	});

export const callingQuery = (organizationId: string, connectionId: string) =>
	orpc.channels.whatsapp.calling.get.queryOptions({
		input: { organizationId, connectionId },
	});

export const checkoutFlowQuery = (
	organizationId: string,
	connectionId: string,
) =>
	orpc.channels.whatsapp.checkoutFlow.status.queryOptions({
		input: { organizationId, connectionId },
	});

export const metaCatalogQuery = (organizationId: string) =>
	orpc.catalog.meta.get.queryOptions({ input: { organizationId } });

export const templatesQuery = (
	organizationId: string,
	filter: { whatsappAccountId?: string; status?: string } = {},
) =>
	orpc.channels.templates.list.queryOptions({
		input: {
			organizationId,
			...(filter.whatsappAccountId
				? { whatsappAccountId: filter.whatsappAccountId }
				: {}),
			...(filter.status ? { status: filter.status } : {}),
		},
	});

/** The retailer's branches, for "branches served" and entry links. */
export const storesQuery = (organizationId: string) => ({
	...orpc.catalog.overview.queryOptions({ input: { organizationId } }),
	select: (overview: { stores: { externalId: string; name: string }[] }) =>
		overview.stores,
});
